import moment from 'moment-timezone'

export default ({ lowerValue, upperValue }) =>
  moment(lowerValue).isAfter(upperValue)
